<template>
  <section class="section link-list primary">
    <div class="link-list-content">
      <div class="content-link create-course">
        <div class="link">
          <a
            class="link-content unique"
            :class="[isActiveTab(1)? 'active': '']"
            @click="setActiveTab(1)"
          >
            Curso
          </a>
        </div>
      </div>
    </div>
  </section>
  <section
    class="section config-form primary"
    :class="[isActiveTab(1)? 'active': '']"
  >
    <CourseDetail :saved="hassaved" @save="updatevalue" />
  </section>
</template>

<script>
import CourseDetail from './tabs/details.vue'
import GetModulesApi from "@/utils/modules"
import Loader from '@/components/Loader/loader.vue'
import { mapState } from 'vuex';



export default {
  data() {
    return {
      activeTab: 1,
      hassaved:false,
      modules: [],
      openmodalmodule:false,
      isReady:false,
    }
  },
  props: {

  },
  computed:{
  ...mapState(['typeId','isAuthenticated','token','websites'])
},
  components: {
    CourseDetail,
    Loader
  },
  methods: {
    async GetAllModules(){

    try{
      const response = await GetModulesApi.getDataModules(this.token);
      this.modules=response.content;
      this.isReady=true;
    } catch(error){
      console.error('Error fetching API:', error);
    }
  },
    updatevalue(novoValor){
      this.hassaved = novoValor;
    },

    setActiveTab(tabNumber) {
      this.activeTab = tabNumber;
    },
    isActiveTab(tabNumber) {
      return this.activeTab === tabNumber;
    },
    openmodal(){
        this.openmodalmodule = !this.openmodalmodule;
    },
      atualizarValorNoFilho(novoValor) {
      this.openmodalmodule = novoValor;
    }
  },
  created() {
    this.GetAllModules();
  },
}
</script>

<style scoped>
@import "./createcourse.css";
</style>
